module.exports = "/images/info.svg?fe78d7f4389fd1a5851675b5b65048c4";